import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CarGasolineDrawer from "./modules/CarGasolineDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import { getAction } from '@api/manage';
import moment from 'moment';
export default {
  name: 'CarGasolineList',
  mixins: [JeecgListMixin],
  components: {
    CarGasolineDrawer: CarGasolineDrawer
  },
  props: {
    carId: {
      type: Number,
      default: null
    },
    carDetails: Boolean
  },
  data: function data() {
    return {
      permissionObj: {
        add: 'car:ea_asset_car_gasoline:add',
        delete: 'car:ea_asset_car_gasoline:delete',
        edit: 'car:ea_asset_car_gasoline:edit',
        deleteBatch: 'car:ea_asset_car_gasoline:deleteBatch'
      },
      pagePath: '/ea/asset/car/gasoline',
      pageTitle: '车辆加油记录',
      userTree: [],
      //人员信息
      carList: [],
      detailsFlag: this.carDetails,
      carShow: true,
      autoLoadInit: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'gasolineDate',
        colName: 'gasoline_date',
        title: '日期',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'card',
        colName: 'card',
        title: '车牌号',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'depart',
        colName: 'depart',
        title: '部门',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '加油人员',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'apparentKilometer',
        colName: 'apparent_kilometer',
        title: '表显公里数',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'refuelingVolume',
        colName: 'refueling_volume',
        title: '加油量/L',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'refuelingAmount',
        colName: 'refueling_amount',
        title: '加油金额',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'cardBalance',
        colName: 'card_balance',
        title: '油卡余额',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        carList: '/ea/asset/car/queryCarCards'
      },
      userId: 1,
      loginUser: '',
      queryParam: {
        column: 'create_time',
        order: 'desc'
      }
    };
  },
  created: function created() {
    this.queryParam.gasolineDateStart = moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.gasolineDateEnd = moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss');

    if (this.carDetails) {
      this.queryParam.carId = this.carId;
      this.carShow = !this.carDetails;
    }

    this.queryCarList();
    this.loadTreeList();
    this.model = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    this.keys = JSON.parse(window.localStorage.getItem('pro__Login_Userinfo'));

    if (!(this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('Finance'))) {
      this.queryParam.userId = this.keys.value.id;
    }

    console.log('roleList', this.queryParam.userId);
    this.loadData();
  },
  computed: {},
  methods: {
    moment: moment,
    searchReset: function searchReset() {
      this.queryParam = {
        carId: this.carId,
        column: 'create_time',
        order: 'desc'
      };

      if (!(this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('Finance'))) {
        this.queryParam.userId = this.keys.value.id;
      }

      this.dates = {};
      this.loadData(1);
    },
    // modalFormOk() {
    //   this.queryParam = { carId: this.carId }
    //   this.loadData(1)
    // },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.activeKey = '1';
      this.$refs.modalForm.showInput = false;
      this.$refs.modalForm.carDisableStatus = true;
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record);

      if (!this.carDetails) {
        this.$refs.modalForm.carDisableStatus = false;
      }

      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    getAuth: function getAuth(id) {
      if (this.$store.getters.userInfo.roleList.includes('administrator') || this.$store.getters.userInfo.roleList.includes('tenant_admin')) {
        return true;
      } else {
        return id == this.$store.getters.userInfo.id && this.buTime - this.addTime < 60 * 60 * 1000;
      }
    },
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    onDateGasolineDate: function onDateGasolineDate(value, dateArray) {
      this.queryParam.gasolineDateStart = dateArray[0] != "" ? dateArray[0] + ' 00:00:00' : null;
      this.queryParam.gasolineDateEnd = dateArray[1] != "" ? dateArray[1] + ' 23:59:59' : null;
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};